var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.meta)?_c('span',{staticClass:"label",class:_vm.meta.class,attrs:{"title":"Signoff status"}},[_vm._v("\n    "+_vm._s(_vm.meta.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }